import {
    GET_ElResi,
    ADD_ElResi,
    TOGGLE_ElResi,
    RESET_ElResi,
    UPDATE_ElResi
  } from "../actionTypes";

const elderResidencesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ElResi:
      return action.payload;

    case ADD_ElResi:
      return action.payload;

    case UPDATE_ElResi:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_ElResi:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_ElResi:
      return null;

    default:
      return state;
  }
};

export default elderResidencesReducer;
